export default __webpack_public_path__ + "static/media/device-img.d7b7c8a1.png";